import { useQuery } from 'react-query';
import { QueryKey } from 'src/models/query';
import { eventsSitemapGqlQuery } from 'src/modules/events/graphql/events-sitemap.query';
import { fetchPublicDirectusGqlItems } from 'src/services/directus/common';

export const fetchSitemapEvents = async () => {
  return fetchPublicDirectusGqlItems(eventsSitemapGqlQuery).then(
    (a) => a.events,
  );
};

export const useEventsSitemapQuery = () => {
  return useQuery(QueryKey.EventsSitemap, fetchSitemapEvents);
};
